import React from "react";
import { Navigate } from "react-router-dom";
import { getStorage } from "./utilityfunctions";

const ProtectedPrimaryRoute = ({ children }) => {
  const authData = JSON.parse(getStorage("authData") || "{}");

  const isSubAccountSelected =
    authData?.selectedSubAccount &&
    typeof authData.selectedSubAccount === "object";

  // If subaccount selected → block
  if (isSubAccountSelected) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default ProtectedPrimaryRoute;